export default {
    backUrl: process.env.REACT_APP_BACK_URL || "",
    apiUrl: process.env.REACT_APP_API_URL || "",
    csrf: process.env.REACT_APP_CSRF_ENABLE || "",
  };